import Page from './campanha-de-indicacao'
export default Page
